define('drops/milestones/milestones',[
    'jquery',
    'lq/drop',
    'lq/util'
], function ($, Drop, util) {
    'use strict';

    var ctx;

    function Milestones(options) {
        Drop.call(this, $('<div/>'), options);
        var self = this;

        self.data.eventing = util.convertListOfKeyValuesToObject(self.data.eventing);
        
        self.milestonesList = [];
        self.selectedDataSourceOutput = '';
        self.TimeLine = new Object();
        self.currentDateRec = null;
        self.selectedData = null;
        self.timeLineFormats = ["Jaren", "Kwartalen", "Maanden", "Weken", "Dagen (maandbasis)", "Dagen (weekbasis)"];
        self.rectTopList = [];
        self.rectBottomList = [];
        self.beschrijvingList = [];

        self.$element
            .addClass('boxToBorderSize')
            .css({
                overflowX: 'auto',
                overflowY: 'hidden',
                'background-color': self.data.color
            });
        
        self.$dropDown = $('<select />')
            .on('change', function (value) {
                self.data.selectedFormat = self.$dropDown.val();
                self.resizeCanvas();
                self.buildTimeLine();
                self._render();
            })
            .css({
                position: "absolute",
                top: "5px",
                left: "20px",
                margin: 0,
                padding: 0
            })
            .appendTo(self.$element);

        self._canvas = $('<canvas />')
            .appendTo(self.$element);
        
        for (var i = 0; i < self.timeLineFormats.length; i++) {
            var $dropDown = $('<option />')
                .val(self.timeLineFormats[i])
                .text(self.timeLineFormats[i])
                .appendTo(self.$dropDown);
            if (self.data.selectedFormat === self.timeLineFormats[i]) {
                $dropDown.prop('selected', true);
            }
        }
    };

    Drop.extend(Milestones, Drop);

    Milestones.typeName = 'Milestones';

    Milestones.prototype.preRender = function () {
        this.piping.visibility.apply(this);

        var self = this;
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function(data) {
                self.update(data);
            });

        this.formatter = this.piping.formatting.createFormatter();
        this.applyPosition();
    };

    Milestones.prototype.postRender = function () {
        this.buildCanvas();
    };

    Milestones.prototype.update = function (update) {
        var self = this;
        
        var result = [];
        for (var i = 0; i < update.results.length; i++) {
            var dataItem = update.results[i];
            var milestone = {
                id: dataItem[self.data.idOutput],
                naam: dataItem[self.data.naamOutput],
                beschrijving: dataItem[self.data.beschrijvingOutput],
                datumPlanning: dataItem[self.data.datumPlanningOutput] ? self.formatter.parseLicquidDate(dataItem[self.data.datumPlanningOutput]) : null,
                datumWerkelijk: dataItem[self.data.datumWerkelijkOutput] ? self.formatter.parseLicquidDate(dataItem[self.data.datumWerkelijkOutput]) : null
            };
            result.push(milestone);
        }
        self.milestonesList = result;
        for (var j = 0; j < self.milestonesList.length; j++) {
            if (self.milestonesList[j].datumPlanning)
                self.milestonesList[j].datumPlanning.setHours(12);
            if (self.milestonesList[j].datumWerkelijk)
                self.milestonesList[j].datumWerkelijk.setHours(12);
        }

        self.buildTimeLine();
        self._render();
    };

    Milestones.prototype._getMinAndMaxDate = function () {
        var self = this;
        
        var msl = self.milestonesList;
        var smallest = Number.MAX_VALUE;
        var largest = Number.MIN_VALUE;

        for (var i = 0; i < msl.length; i++) {
            var milestone = msl[i];

            if (milestone.datumPlanning) {
                smallest = Math.min(smallest, milestone.datumPlanning.getTime());
                largest = Math.max(largest, milestone.datumPlanning.getTime());
            }
            
            if (milestone.datumWerkelijk) {
                smallest = Math.min(smallest, milestone.datumWerkelijk.getTime());
                largest = Math.max(largest, milestone.datumWerkelijk.getTime());
            }
        }
        return { min: new Date(smallest), max: new Date(largest) };
    };

    Milestones.prototype.buildTimeLine = function () {
        var self = this;
        var minMax = self._getMinAndMaxDate();
        var smallest = minMax.min;
        var largest = minMax.max;


        self.TimeLine.cellText = [];
        self.TimeLine.dates = [];
       
        switch (self.data.selectedFormat) {
            case 'Jaren':
                smallest = new Date(smallest.getFullYear(), 0);
                l = parseInt(largest.getFullYear() + 1);
                self.TimeLine.amount = l - smallest.getFullYear();
                largest = new Date(l, 0);

                for (var j = 0; j < self.TimeLine.amount; j++) {
                    self.TimeLine.cellText[j] = smallest.getFullYear() + j;
                }
                break;

            case 'Kwartalen':
                smallest = new Date(smallest.getFullYear(), 0);
                l = parseInt(largest.getFullYear() + 1);
                self.getYears(smallest, l);

                var l = parseInt(largest.getFullYear() + 1);
                self.TimeLine.amount = (l * 4) - (smallest.getFullYear() * 4);
                largest = new Date(l, 0);

                var f = 0;
                for (var j = 0; j < self.TimeLine.amount; j++) {
                    if (f === 4)
                        f = 0;
                    f++;
                    self.TimeLine.cellText[j] = 'Q' + (f);
                }
                break;

            case 'Maanden':
                smallest = new Date(smallest.getFullYear(), smallest.getMonth());
                largest = new Date(largest.getFullYear(), largest.getMonth() + 1);
                self.getYears(smallest, parseInt(largest.getFullYear() + 1), largest);

                self.TimeLine.amount = (largest.getMonth() - smallest.getMonth()) + (12 * (largest.getFullYear() - smallest.getFullYear()));

                for (var m = 0; m < self.TimeLine.amount; m++) {
                    var monthText = self.getMonthText(new Date(smallest.getFullYear(), smallest.getMonth() + m).getMonth());

                    self.TimeLine.cellText[m] = monthText.letter;
                }
                break;

            case 'Weken':
                smallest = new Date(smallest.getFullYear(), smallest.getMonth(), smallest.getDate() - smallest.getDay());
                largest = new Date(largest.getFullYear(), largest.getMonth(), largest.getDate() + 7 - largest.getDay());
                self.getYears(smallest, parseInt(largest.getFullYear() + 1), largest);
                self.TimeLine.amount = Math.round((largest / (1000 * 60 * 60 * 24 * 7))) - Math.round((smallest / (1000 * 60 * 60 * 24 * 7)));
                self.calcWeeks(smallest);
                break;

            case 'Dagen (maandbasis)':
                smallest = new Date(smallest.getFullYear(), smallest.getMonth(), smallest.getDate());
                largest = new Date(largest.getFullYear(), largest.getMonth(), largest.getDate() + 1);
                self.getMonths(smallest, largest);
                self.TimeLine.amount = Math.round((largest / (1000 * 60 * 60 * 24))) - Math.round((smallest / (1000 * 60 * 60 * 24)));

                for (var n = 0; n < self.TimeLine.amount; n++) {
                    self.TimeLine.cellText[n] = new Date(smallest.getFullYear(), smallest.getMonth(), smallest.getDate() + n).getDate();
                }
                break;

            case 'Dagen (weekbasis)':
                smallest = new Date(smallest.getFullYear(), smallest.getMonth(), smallest.getDate());
                largest = new Date(largest.getFullYear(), largest.getMonth(), largest.getDate() + 1);
                self.TimeLine.amount = Math.round((largest / (1000 * 60 * 60 * 24))) - Math.round((smallest / (1000 * 60 * 60 * 24)));
                self.getWeeks(smallest, largest);
                for (var n = 0; n < self.TimeLine.amount; n++) {
                    self.TimeLine.cellText[n] = self.getWeekDayText(new Date(smallest.getFullYear(), smallest.getMonth(), (smallest.getDate() + n)).getDay());
                }
                break;

            default:
        }

        self.TimeLine.largestDate = largest;
        self.TimeLine.smallestDate = smallest;
        self.TimeLine.lineWidth = 25;

        self.buildCells();
    };

    Milestones.prototype.getMonths = function (smallest, largest) {
        var self = this;
        var months = (largest.getMonth() - smallest.getMonth()) + (12 * (largest.getFullYear() - smallest.getFullYear())) + 1;

        for (var i = 0; i < months; i++) {
            var low = new Date(smallest.getFullYear(), smallest.getMonth() + i);
            var high = new Date(smallest.getFullYear(), smallest.getMonth() + i + 1, 0, 0, -1);

            if (low.getTime() < smallest.getTime())
                low = smallest;
            if (largest.getTime() < high.getTime())
                high = largest;

            var monthText = self.getMonthText(low.getMonth());
            var date = {
                text: (monthText.text + ' ' + low.getFullYear()),
                low: low,
                high: high
            };
            self.TimeLine.dates[i] = date;


        }
    };



    Milestones.prototype.getYears = function (s, l, largest) {
        var self = this;
        var years = l - s.getFullYear();

        for (var k = 0; k < years; k++) {
            var low = new Date(s.getFullYear() + k, 0);
            var high = new Date(s.getFullYear() + k + 1, 0, 0, 0, -1);
            if (low.getTime() < s.getTime())
                low = s;

            if (largest) {
                if (largest.getTime() < high.getTime()) {
                    high = largest;
                }
            }
            var date = {
                text: s.getFullYear() + k,
                low: low,
                high: high
            };

            self.TimeLine.dates[k] = date;
        }
    };

    Milestones.prototype.getWeeks = function (smallest, largest) {
        var self = this;

        var s = new Date(smallest.getFullYear(), smallest.getMonth(), smallest.getDate() - smallest.getDay());
        var day = new Date(s.getFullYear(), 0).getDay();
        var year = new Date(s.getFullYear(), 0, 1 - day);
        var week = Math.round(s / (1000 * 60 * 60 * 24 * 7)) - Math.round((year / (1000 * 60 * 60 * 24 * 7)));
        var amount = Math.round((largest / (1000 * 60 * 60 * 24 * 7))) - Math.round((smallest / (1000 * 60 * 60 * 24 * 7))) + 1;
        for (var i = 0; i < amount; i++) {
            if (week > 52 || week === 0)
                week = 1;
            var low = new Date(s.getFullYear(), s.getMonth(), s.getDate() + (i * 7));
            var high = new Date(s.getFullYear(), s.getMonth(), s.getDate() + ((i + 1) * 7));

            if (low.getTime() < smallest.getTime())
                low = smallest;
            if (high.getTime() > largest.getTime())
                high = largest;

            var date = {
                text: week + '/' + new Date(s.getFullYear(), s.getMonth(), s.getDate() + (i * 7)).getFullYear(),
                low: low,
                high: high

            };
            self.TimeLine.dates[i] = date;
            week++;
        }

    };

    Milestones.prototype.calcWeeks = function (smallest) {
        var self = this;
        var day = new Date(smallest.getFullYear(), 0).getDay();
        var year = new Date(smallest.getFullYear(), 0, 1 - day);
        var smallestDate = new Date(smallest.getFullYear(), smallest.getMonth(), smallest.getDate());
        var week = Math.round(smallestDate / (1000 * 60 * 60 * 24 * 7)) - Math.round((year / (1000 * 60 * 60 * 24 * 7)));
        for (var i = 0; i < self.TimeLine.amount; i++) {
            if (week > 52 || week === 0)
                week = 1;

            self.TimeLine.cellText[i] = week;
            week++;
        }
    };

    Milestones.prototype.buildCells = function () {
        var self = this;

        self.resizeCanvas();
        self.TimeLine.cells = [];
        for (var i = 0; i < self.TimeLine.amount; i++) {
            var cell = {
                text: self.TimeLine.cellText[i],
                fontSizeLimit: '12',
                milestonesPlanning: [],
                milestonesWerkelijk: [],
                colorStroke: "rgba(20,20,20,1)",
                colorFill: "rgba(240,240,240,1)"
            };

            self.TimeLine.cells[i] = cell;
        }
    };

    Milestones.prototype.canvasClick = function (e) {
        var self = this;
        var pos = { x: e.offsetX, y: e.offsetY };
        var done = false;

        if (!done && self.beschrijvingList.length > 0) {
            done = self.toggleDescription(self.beschrijvingList, pos, 'close');
        }
        if (!done && self.rectTopList.length > 0) {
            done = self.toggleDescription(self.rectTopList, pos, 'build');
        }
        if (!done && self.rectBottomList.length > 0) {
            self.toggleDescription(self.rectBottomList, pos, 'build');
        }
        self.drawAll();
    };

    Milestones.prototype.resizeCanvas = function () {
        var self = this;
        if (!self._canvas || self._canvas === undefined)
            return;

        self._canvas.width = self.data.size.x;
        self._canvas.height = self.data.size.y;

        var width = self.TimeLine.amount * self.canvasCellWidth(self.selectedFormat);
        if (width > 14000)
            width = 14000;

        if (width > self.data.size.x)
            self._canvas.width = width;

        self._canvas.attr('height', self._canvas.height)
        self._canvas.attr('width',self._canvas.width)
    };

    Milestones.prototype.buildCanvas = function () {
        var self = this;

        self._canvas.on('click', function (e) {
            self.canvasClick(e);
        });

        self.resizeCanvas();

        ctx = self._canvas[0].getContext("2d");
    };


    Milestones.prototype._render = function () {
        var self = this;
        if (!self._canvas || self._canvas === undefined)
            return;

        var buffer = 100;
        self.TimeLine.buffer = buffer;

        var cellWidth = ((self._canvas.width) - (buffer * 2)) / self.TimeLine.amount;
        for (var i = 0; i < self.TimeLine.amount; i++) {
            self.TimeLine.cells[i].x = buffer + i * (cellWidth);
            self.TimeLine.cells[i].y = self._canvas.height / 2 - self.TimeLine.lineWidth / 2;
            self.TimeLine.cells[i].w = cellWidth;
            self.TimeLine.cells[i].h = self.TimeLine.lineWidth;

            self.TimeLine.cells[i].loc = self.TimeLine.cells[i].x + (self.TimeLine.cells[i].w / 2);

        }
        self.buildMilestones();
        self.buildCurrentDate();
        self.buildTimeLineDates();
        self.drawAll();

    };

    Milestones.prototype.buildCurrentDate = function () {
        var self = this;
        var currentDate = new Date();
        if (currentDate <= self.TimeLine.largestDate && currentDate >= self.TimeLine.smallestDate) {
            var locCurrentDate = self.getLoc(currentDate);
            var rectC = {
                text: "Current Date",
                date: currentDate.toLocaleDateString(),
                x: locCurrentDate - (ctx.measureText("Current Date").width / 2) - 15,
                y: self._canvas.height / 2.9,
                w: ctx.measureText("Current Date").width + 30,
                h: self._canvas.height / 12,
                colorFill: "rgba(240,240,240,1)",
                colorStroke: "rgba(190,90,90,1)",
                fontSizeLimit: 11
            };
            self.currentDateRec = { rec: rectC, loc: locCurrentDate };
        } else {
            self.currentDateRec = null;
        }
    };

    Milestones.prototype.buildTimeLineDates = function () {
        var self = this;
        if (self.TimeLine.dates[0] === undefined || self.TimeLine.dates[0] === null)
            return;

        for (var i = 0; i < self.TimeLine.dates.length; i++) {
            var date = self.TimeLine.dates[i];
            var low = self.getLoc(date.low);
            var high = self.getLoc(date.high);
            self.TimeLine.dates[i].loc = Math.round((low + high) / 2);
        }
    };

    Milestones.prototype.getLoc = function (date) {
        var self = this;
        var loc;
        var width = self._canvas.width - (self.TimeLine.buffer * 2);

        loc = width / ((self.TimeLine.largestDate.getTime() - self.TimeLine.smallestDate.getTime()) / (date.getTime() - self.TimeLine.smallestDate.getTime()));
        loc += self.TimeLine.buffer;
        return loc;
    };

    Milestones.prototype.toggleDescription = function (rl, pos, action) {
        var self = this;
        for (var i = rl.length - 1; i >= 0; i--) {
            if (pos.x >= rl[i].x && pos.x <= (rl[i].x + rl[i].w) &&
				pos.y >= rl[i].y && pos.y <= (rl[i].y + rl[i].h)) {

                if (rl !== self.beschrijvingList) {
                    var id = rl[i].id;
                    self.triggerEvent(self.data.eventing.clicked.raisedEventName, id);
                }

                if (action === 'build') {

                    for (var j = 0; j < self.beschrijvingList.length; j++) {
                        if (self.beschrijvingList[j].rec === rl[i])
                            return false;
                    }

                    if (rl[i].beschrijving === undefined || rl[i].beschrijving === "")
                        return false;

                    ctx.font = 12 + 'px Tahoma';

                    var text = rl[i].beschrijving ? rl[i].beschrijving.split(/[\n\s]/) : '';

                    var beschrijving = [];
                    var maxWidth = rl[i].w + 20;
                    var y = rl[i].y;
                    var index = 0;

                    beschrijving[index] = 'Beschrijving:';
                    index++;
                    beschrijving[index] = '';
                    for (var k = 0; k < text.length; k++) {

                        if (ctx.measureText(beschrijving[index]).width >= maxWidth) {
                            index++;
                            beschrijving[index] = '';
                        }
                        beschrijving[index] += text[k] + " ";
                    }

                    var rectDescr = {
                        text: beschrijving,
                        x: rl[i].x - 30,
                        y: y,
                        w: maxWidth + 40,
                        h: 25 * beschrijving.length,
                        colorFill: "rgba(240,240,240,0.95)",
                        colorStroke: "rgba(0,0,110,1)",
                        rec: rl[i]
                    };

                    if (rectDescr.h + y > self._canvas.height) {

                        var overflowY = (rectDescr.h + y) - self._canvas.height;
                        rectDescr.y = y - overflowY;
                    }

                    if (rectDescr.x < 0)
                        rectDescr.x = 0;

                    if (rectDescr.x + rectDescr.w > self._canvas.width) {
                        var overflowX = (rectDescr.w + rl[i].x) - self._canvas.width;
                        rectDescr.x = rl[i].x - overflowX;
                    }

                    self.beschrijvingList.push(rectDescr);
                    return true;
                }
                else if (action === 'close') {
                    self.beschrijvingList.splice(i, 1);
                    return true;
                }
            }
        }
        return false;
    };

    Milestones.prototype.buildMilestones = function () {
        var self = this;
        ctx.lineWidth = 1;
        self.rectTopList = [];
        self.milestonesList.forEach(function (milestone) {
            if (milestone.datumPlanning == null)
                return;

            var locPlanning = self.getLoc(milestone.datumPlanning);

            var w;

            if (milestone.naam === "" || milestone.naam === undefined)
                w = ctx.measureText(milestone.datumPlanning.toLocaleDateString()).width + 40;
            else
                w = (ctx.measureText(milestone.naam).width) + 40;


            var rectPlanning = {
                id: milestone.id,
                text: milestone.naam,
                beschrijving: milestone.beschrijving,
                date: milestone.datumPlanning.toLocaleDateString(),
                x: (locPlanning - w / 2),
                y: self._canvas.height / 4,
                w: w,
                h: self._canvas.height / 12,
                location: locPlanning,
                colorFill: "rgba(240,240,245,1)",
                colorStroke: "rgba(0,0,110,1)",
                type: 'p',
                fontSizeLimit: 10,
                yIndex: 1
            };

            self.rectTopList.push(rectPlanning);
            if (self.rectTopList.length > 0) {
                self.detectCollision(self.rectTopList, rectPlanning);
            }
        });

        self.rectBottomList = [];
        self.milestonesList.forEach(function (milestone) {
            if (milestone.datumWerkelijk == null)
                return;

            var locWerkelijk = self.getLoc(milestone.datumWerkelijk);

            var w;

            if (milestone.naam === "" || milestone.naam === undefined)
                w = ctx.measureText(milestone.datumWerkelijk.toLocaleDateString()).width + 40;
            else
                w = (ctx.measureText(milestone.naam).width) + 40;



            var rectWerkelijk = {
                id: milestone.id,
                text: milestone.naam,
                beschrijving: milestone.beschrijving,
                date: milestone.datumWerkelijk.toLocaleDateString(),
                location: locWerkelijk,
                x: (locWerkelijk - w / 2),
                y: self._canvas.height - (self._canvas.height / 2.5),
                w: w,
                h: self._canvas.height / 12,
                colorFill: "rgba(255,245,240,1)",
                colorStroke: "rgba(160,0,0,1)",
                type: 'w',
                fontSizeLimit: 10,
                yIndex: 1
            };

            self.rectBottomList.push(rectWerkelijk);
            if (self.rectBottomList.length > 0) {
                self.detectCollision(self.rectBottomList, rectWerkelijk);
            }
        });
    };

    Milestones.prototype.getMonthText = function (mnr) {
        switch (mnr) {
            case 0:
                return { letter: 'J', text: 'Januari' };
            case 1:
                return { letter: 'F', text: 'Februari' };
            case 2:
                return { letter: 'M', text: 'Maart' };
            case 3:
                return { letter: 'A', text: 'April' };
            case 4:
                return { letter: 'M', text: 'Mei' };
            case 5:
                return { letter: 'J', text: 'Juni' };
            case 6:
                return { letter: 'J', text: 'Juli' };
            case 7:
                return { letter: 'A', text: 'Augustus' };
            case 8:
                return { letter: 'S', text: 'September' };
            case 9:
                return { letter: 'O', text: 'Oktober' };
            case 10:
                return { letter: 'N', text: 'November' };
            case 11:
                return { letter: 'D', text: 'December' };
            default:
        }
    };

    Milestones.prototype.getWeekDayText = function (wknr) {
        switch (wknr) {
            case 1:
                return 'M';
            case 2:
                return 'D';
            case 3:
                return 'W';
            case 4:
                return 'D';
            case 5:
                return 'V';
            default:
                return 'Z';
        }
    };

    Milestones.prototype.detectCollision = function (rectlist, rect) {
        var self = this;
        var y = rect.y;
        for (var s = rectlist.length - 1; s >= 0; s--) {

            var r2 = rectlist[s];

            if ((rect.x <= (r2.x + r2.w)) && (r2.x <= (rect.x + rect.w)) && r2 !== rect) {
                switch (r2.yIndex) {
                    case 1:
                        rect.yIndex = 2;
                        if (rect.type == 'p')
                            rect.y = r2.y - r2.h - (self._canvas.height / 50);

                        else
                            rect.y = r2.y + r2.h + (self._canvas.height / 50);
                        break;
                    case 2:
                        rect.yIndex = 3;

                        if (rect.type == 'p')
                            rect.y = r2.y - r2.h - (self._canvas.height / 50);
                        else
                            rect.y = r2.y + r2.h + (self._canvas.height / 50);
                        break;
                    case 3:
                        rect.yIndex = 1;
                        rect.y = y;

                        break;
                    default:
                        break;
                }
                break;
            }
        }
    };


    Milestones.prototype.drawAll = function () {
        var self = this;
        self.clearCanvas();
        if (self.currentDateRec)
            self.drawLine(self.currentDateRec.rec, self.currentDateRec.loc);

        for (var o = 0; o < self.TimeLine.dates.length; o++) {
            self.drawDate(self.TimeLine.dates[o]);
        }
        for (var n = 0; n < self.TimeLine.cells.length; n++) {
            self.drawBox(self.TimeLine.cells[n]);
        }
        for (var i = 0; i < self.rectTopList.length; i++)
            self.drawLine(self.rectTopList[i], self.rectTopList[i].location);

        for (var j = 0; j < self.rectTopList.length; j++)
            self.drawBox(self.rectTopList[j], self.rectTopList[j].location);

        for (var k = 0; k < self.rectBottomList.length; k++)
            self.drawLine(self.rectBottomList[k], self.rectBottomList[k].location);

        for (var l = 0; l < self.rectBottomList.length; l++)
            self.drawBox(self.rectBottomList[l], self.rectBottomList[l].location);

        if (self.currentDateRec) {
            self.drawBox(self.currentDateRec.rec, self.currentDateRec.loc);
        }
        for (var m = 0; m < self.beschrijvingList.length; m++)
            self.drawDescription(self.beschrijvingList[m]);

    };

    Milestones.prototype.drawDate = function (date) {
        var self = this;
        ctx.fillStyle = "rgba(20,20,20,1)";
        ctx.strokeStyle = "rgba(20,20,20,1)";
        ctx.font = 13 + 'pt Tahoma';
        ctx.textAlign = 'center';
        ctx.lineWidth = 1;

        var width = ctx.measureText(date.text).width;
        ctx.fillText(date.text, date.loc, self._canvas.height / 2.15, width * 2);

    };

    Milestones.prototype.drawLine = function (rect, loc) {
        var self = this;
        var start = self._canvas.height / 2 + (self.TimeLine.lineWidth / 2);
        if (rect.type === 'p') {
            start = self._canvas.height / 2 - (self.TimeLine.lineWidth / 2);
        }
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.strokeStyle = rect.colorStroke;
        ctx.moveTo(loc, start);
        ctx.lineTo(loc, rect.y);
        ctx.stroke();
    };

    Milestones.prototype.drawDescription = function (rect) {
        var self = this;

        ctx.lineWidth = 1;
        ctx.font = 10 + 'pt Tahoma';
        ctx.fillStyle = rect.colorFill;
        ctx.strokeStyle = rect.colorStroke;
        ctx.strokeRect(rect.x, rect.y, rect.w, rect.h);
        ctx.fillRect(rect.x, rect.y, rect.w, rect.h);
        ctx.fillStyle = "rgba(20,20,20,1)";
        ctx.textAlign = "center";
        for (var i = 0; i < rect.text.length; i++) {
            ctx.fillText(rect.text[i], rect.x + (rect.w / 2), rect.y + ((i + 1) * 20), rect.w);
        }

    };

    Milestones.prototype.drawBox = function (rect, loc) {
        var self = this;
        if (!loc)
            loc = rect.x + (rect.w / 2);

        ctx.lineWidth = 1;
        ctx.fillStyle = rect.colorFill;
        ctx.strokeStyle = rect.colorStroke;
        ctx.fillRect(rect.x, rect.y, rect.w, rect.h);
        ctx.strokeRect(rect.x, rect.y, rect.w, rect.h);

        ctx.textAlign = 'center';
        var fontSize = Math.round((self.data.size.x) / 110);

        if (fontSize < 10)
            fontSize = 10;
        if (fontSize > 16)
            fontSize = 16;

        if (fontSize > rect.fontSizeLimit)
            fontSize = rect.fontSizeLimit;

        ctx.font = fontSize + 'pt Tahoma';
        ctx.fillStyle = "rgba(20,20,20,1)";
        if (rect.date) {
            ctx.fillText(rect.text, loc, rect.y + rect.h / 3, rect.w, rect.h / 3);
            ctx.fillText(rect.date, loc, rect.y + rect.h - rect.h / 3, rect.w, rect.h / 3);

        } else {
            ctx.fillText(rect.text, loc, rect.y + rect.h - rect.h / 3, rect.w, rect.h);
        }
        ctx.closePath();
    };

    Milestones.prototype.clearCanvas = function () {
        var self = this;
        ctx.clearRect(0, 0, self._canvas.width, self._canvas.height);
    };

    Milestones.prototype.canvasCellWidth = function (format) {
        switch (format) {
            case "Jaren":
                return 600;
            case "Kwartalen":
                return 150;
            case "Maanden":
                return 150;
            case "Weken":
                return 130;
            default:
                return 30;
        }
    };


    Milestones.prototype.canSave = function () {
        var self = this;
        return self.dirtyCheck().isDirty()
			&& $.trim(self.name) != '';
    };

    return Milestones;
});




